export default [
  { name: 'Amazonas', code: 'PE-AMA' },
  { name: 'Áncash', code: 'PE-ANC' },
  { name: 'Apurímac', code: 'PE-APU' },
  { name: 'Arequipa', code: 'PE-ARE' },
  { name: 'Ayacucho', code: 'PE-AYA' },
  { name: 'Cajamarca', code: 'PE-CAJ' },
  { name: 'Callao', code: 'PE-CAL' },
  { name: 'Cuzco', code: 'PE-CUS' },
  { name: 'Huancavelica', code: 'PE-HUV' },
  { name: 'Huánuco', code: 'PE-HUC' },
  { name: 'Ica', code: 'PE-ICA' },
  { name: 'Junín', code: 'PE-JUN' },
  { name: 'La Libertad', code: 'PE-LAL' },
  { name: 'Lambayeque', code: 'PE-LAM' },
  { name: 'Lima (departamento)', code: 'PE-LIM' },
  { name: 'Lima (provincia)', code: 'PE-LMA' },
  { name: 'Loreto', code: 'PE-LOR' },
  { name: 'Madre de Dios', code: 'PE-MDD' },
  { name: 'Moquegua', code: 'PE-MOQ' },
  { name: 'Pasco', code: 'PE-PAS' },
  { name: 'Piura', code: 'PE-PIU' },
  { name: 'Puno', code: 'PE-PUN' },
  { name: 'San Martín', code: 'PE-SAM' },
  { name: 'Tacna', code: 'PE-TAC' },
  { name: 'Tumbes', code: 'PE-TUM' },
  { name: 'Ucayali', code: 'PE-UCA' }
];
